module.exports = __webpack_public_path__ + "img/home_52.ec391fb4.png";